import { render, staticRenderFns } from "./SelRefined.vue?vue&type=template&id=b0ed0bfe&lang=pug"
import script from "./SelRefined.vue?vue&type=script&lang=js"
export * from "./SelRefined.vue?vue&type=script&lang=js"
import style0 from "./SelRefined.vue?vue&type=style&index=0&id=b0ed0bfe&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/vantone/Icon.vue').default})
